import React, { useState, useEffect } from 'react';

import { usePokCore } from '../../../common/hooks/usePokCore';
import { GetStageDefinitionDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { useNotifications } from '../../../common/hooks/useNotifications';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { TimelineStageObj } from '../../../common/pokCore/validation/enums';

import { Selector, Option } from './Selector';

export interface StageSelectorProps {
  readOnly?: boolean;
  className?: string;
  onChange?: (option: Option) => void;
  value?: string;
  clearable?: boolean;
}

export default (props: StageSelectorProps) => {
  const pok = usePokCore();
  const notifications = useNotifications();
  const [stages, setStages] = useState<GetStageDefinitionDto[]>([]);
  const { t } = useTranslation('projectLng');

  useEffect(() => {
    let mounted = true;

    pok.stageDefinitions
      .getAll()
      .then(data => {
        if (mounted) {
          setStages(data);
        }
      })
      .catch(errorResponse => {
        notifications.caughtError(errorResponse);
      });

    return () => {
      mounted = false;
    };
  }, [notifications, pok.stageDefinitions]);

  const provider = async (text: string) => {
    const values = stages
      .sort(
        (a, b) =>
          t(TimelineStageObj[a.stageType])?.localeCompare(
            t(TimelineStageObj[b.stageType]) || '',
          ) || 0,
      )
      .filter(v =>
        t(TimelineStageObj[v.stageType])
          ?.toLocaleLowerCase()
          .includes(text.toLocaleLowerCase()),
      );

    return values.map(v => {
      return {
        badge: '',
        label: t(TimelineStageObj[v.stageType]),
        value: v.id,
      };
    });
  };

  return (
    <Selector
      uniqueKey={'stage-' + JSON.stringify(stages)}
      className={props.className}
      readOnly={props.readOnly}
      creatable={false}
      clearable={props.clearable}
      provider={provider}
      value={props.value}
      onChange={option => props.onChange && props.onChange(option as Option)}
    />
  );
};
